import { render, staticRenderFns } from "./OperationTicketDetails.vue?vue&type=template&id=152a2ec9&scoped=true"
import script from "./OperationTicketDetails.vue?vue&type=script&lang=js"
export * from "./OperationTicketDetails.vue?vue&type=script&lang=js"
import style0 from "./OperationTicketDetails.vue?vue&type=style&index=0&id=152a2ec9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152a2ec9",
  null
  
)

export default component.exports